<template>
    <div id="home-page">
        <div class="nav-space"></div>
        <Introduction />
        <News />
        <Experience />
        <Scholarship />
        <Services />
        <!-- <Timetable /> -->
        <!-- <div class="clustrmaps-container" ref="clustrmapsContainer"></div> -->
        <a href="https://clustrmaps.com/site/1c855"  title="ClustrMaps" class="clustrmaps">
            <img src="//www.clustrmaps.com/map_v2.png?d=QOWD1jt2UHdftt_tv2GyanK54e4frnORQyOCf3x2vqM&cl=ffffff" />
        </a>
    </div>
</template>

<script>
import Introduction from '../components/home/Introduction.vue'
import News from '../components/home/News.vue'
import Experience from '../components/home/Experience.vue'
import Scholarship from '../components/home/Scholarship.vue'
import Services from '../components/home/Services.vue'
// import Timetable from '../components/home/Timetable.vue'

export default {
    name: 'HomePage',
    metaInfo: {
        title: 'Man Ho Lam',
        meta: [
        {
            name: 'keywords',
            content: 'Man Ho Lam, Lam Man Ho, Lam Man Ho Donald, Donald Lam, Man Ho, The Chinese University of Hong Kong, CUHK, ARISE, PhD, Computer Science'
        },
        {
            name: 'description',
            content: 'Man Ho Lam is a Ph.D. student in ARISE Lab, The Chinese University of Hong Kong.'
        }
        ]
    },
    components: {Introduction, News, Experience, Scholarship, Services},
    mounted() {
        this.addClustrMapsScript();
    },
    methods: {
        addClustrMapsScript() {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = 'clstr_globe';
        script.src = '//clustrmaps.com/globe.js?d=chjV4vpQXOS4QA2FJpbiewKRWpvYzKrmEOUOX9Muz08';
        this.$refs.clustrmapsContainer.appendChild(script);
        },
    },
    data() {
        return {
            loaded: false,
        }
    },
    mounted() {
        window.addEventListener('load', () => {
            this.loaded = true
        })
    },
}
</script>

<style>
h1{
    font-size: 30px;
    line-height: 1.5;
    text-align: center;
    color: #111111;
    font-family: "Comic Sans MS", "Comic Sans", "cursive";
    font-weight: bolder;
}

a {
    text-decoration: none;
    color: #3670C9;
    cursor: pointer;
}

a:hover {
    color: #FF5733;
}

.nav-space{
    height: 50px;
    background-color: #181e2def;
}

.clustrmaps {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px auto;
  padding: 20px;
  border-radius: 12px;
  width: fit-content;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.clustrmaps:hover {
  transform: scale(1.05);
}

.clustrmaps img {
  display: block;
  width: 250px;
  height: auto;
  border-radius: 8px;
}
</style>